import React from 'react';

const NotMatch = () => {
    return (
        <div>
            <h1>404 error</h1>
        </div>
    );
};

export default NotMatch;